import { useAppSelector } from "@sso/hooks/useRedux";
import { selectSoftwareLicenceQuery } from "@sso/store/slices/softwareLicence";

import { useSoftwareLicencesQuery } from "..";

export const useGetSoftwareLicencesQuery = () => {
  const queryParams = useAppSelector(selectSoftwareLicenceQuery);
  return useSoftwareLicencesQuery(queryParams);
};
